/**
 * libsodium init singleton.
 *
 * libsodium-wrappers-sumo loads a WASM module asynchronously; `sodium.ready`
 * must resolve before any `crypto_*` call. We centralise the await in
 * {@link initSodium} and fail loud via {@link getSodium} if a consumer forgot —
 * rather than the cryptic "undefined is not a function" of a cold call.
 */
import sodium from 'libsodium-wrappers-sumo';
import { SodiumNotInitialisedError } from './errors.js';
let ready = false;
let readyPromise;
/** Await libsodium readiness. Idempotent — safe to call from every consumer. */
export function initSodium() {
    if (ready) {
        return Promise.resolve();
    }
    if (readyPromise === undefined) {
        readyPromise = sodium.ready.then(() => {
            ready = true;
        });
    }
    return readyPromise;
}
/**
 * Synchronous accessor for the initialised sodium instance.
 * @throws {@link SodiumNotInitialisedError} if called before `initSodium()` resolved.
 */
export function getSodium() {
    if (!ready) {
        throw new SodiumNotInitialisedError();
    }
    return sodium;
}
/** Test-only: reset the singleton so the before-ready path can be exercised. @internal */
export function __resetSodiumForTest() {
    ready = false;
    readyPromise = undefined;
}
//# sourceMappingURL=sodium.js.map